import { apiRequest } from './queryClient';

export interface User {
  id: number;
  username: string;
  email: string;
  fullName: string;
}

export interface AuthResponse {
  message: string;
  token: string;
  user: User;
}

export interface LoginData {
  email: string;
  password?: string;
}

export interface RegisterData {
  email: string;
  fullName: string;
  password: string;
  provider: string;
}

export const authApi = {
  login: async (data: LoginData): Promise<AuthResponse> => {
    const response = await apiRequest('POST', '/api/user/login', data);
    return await response.json();
  },

  resetPassword: async (data: LoginData): Promise<AuthResponse> => {
    const response = await apiRequest('POST', '/api/user/reset-password', data);
    return await response.json();
  },

  register: async (data: RegisterData): Promise<AuthResponse> => {
    const response = await apiRequest('POST', '/api/user/register', data);
    return await response.json();
  },

  getCurrentUser: async (): Promise<User> => {
    const token = localStorage.getItem('auth_token');
    const response = await fetch('ttps://api.devibharat.com/api/auth/me', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch user');
    }
    
    return await response.json();
  },
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem('auth_token');
};

export const setAuthToken = (token: string): void => {
  localStorage.setItem('auth_token', token);
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('auth_token');
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};
